// import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { Fancybox } from "@fancyapps/ui";

function init() {
    Fancybox.bind(document.querySelector("body"), "[data-fancybox]", {
        tpl: {
            closeButton: /* html */ `
                <button data-fancybox-close="" class="f-button is-close-btn" title="Close">
                    <svg width="50" height="51" viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M21.9614 25.2557L21.9246 25.2928L21.966 25.3346L0 47.5253L3.03865 50.595L25 28.409L46.9614 50.595L50 47.5253L28.034 25.3346L28.0754 25.2928L28.0387 25.2557L50 3.06972L46.9614 0L25 22.186L3.03864 0L0 3.06972L21.9614 25.2557Z" fill="#FF3776"/>
                    </svg>
                </button>
            `,
        },
        Carousel : {
            Navigation: {
                prevTpl: `
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        height="60"
                        viewBox="0 0 34 60"
                        width="34"
                        preserveAspectRatio="xMidYMid meet"
                    >
                        <path
                            clip-rule="evenodd"
                            d="M7.17183 29.8739L33.1553 56.123L29.5669 59.748L0.859796 30.7475L0.865278 30.742L0.000543393 29.8684L29.5669 -0.000164319L33.1553 3.6249L7.17183 29.8739Z"
                            fill-rule="evenodd"
                            fill="#FF3776"
                        />
                    </svg>
                `,
                nextTpl: `
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        height="60"
                        viewBox="0 0 34 60"
                        width="34"
                        preserveAspectRatio="xMidYMid meet"
                    >
                        <path
                            clip-rule="evenodd"
                            d="M26.0929 30.0001L-1.61179e-07 56.3597L3.60347 60L32.4312 30.8776L32.4255 30.8717L33.2941 29.9942L3.60347 0.000129544L0 3.64043L26.0929 30.0001Z"
                            fill-rule="evenodd"
                            fill="#FF3776"
                        />
                    </svg>
                `
            },
        }
        // groupAttr: false,
        // on: {
        //     "*": (fancybox, eventName) => {
        //         console.log(`Fancybox eventName: ${eventName}`);
        //     },
        // },
        // Your custom options
    });
}

export { init };
